// extracted by mini-css-extract-plugin
export default {"container":"RR-z","topReviewHeading":"SR-z","criticalReview":"TR-z","favorableReview":"UR-z","vsSeparator":"VR-z"};